// Properties for `admin_event_create_failed` (GIS-273).
//
// Why the create stopped goes under `failureReason`, never `reason`. The
// analytics sanitizer drops any key named `reason` (it is on the shared PII
// blocklist because cancellation reasons are free text), so every one of these
// events used to arrive with no reason on it at all.
export const createFailedProps = (formProps, failureReason, extra) => ({
  ...(formProps || {}),
  failureReason,
  ...(extra || {}),
});
